<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="infoRecord"/>
      <feather-icon icon="LogInIcon" v-if="couldReceive" svgClasses="h-5 w-5 hover:text-danger cursor-pointer ml-3" @click="confirmCustody"/>
      <feather-icon icon="FolderIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer ml-3" @click="confirmDeleteRecord"/>
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  computed: {
    transitState () { return this.params.data.transitState },
    userId () { return JSON.parse(localStorage.getItem('userInfo')).uid },
    lotDeliveryCompanyId () { return this.params.data.deliveryCompanyId },
    userCompanyId () { return JSON.parse(localStorage.getItem('userInfo')).Company.id },
    couldReceive () { return this.userCompanyId === this.lotDeliveryCompanyId && this.transitState !== 'delivered' }
  },
  methods: {
    infoRecord () {
      this.$router.push(`/apps/lot/lot-view/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Arquivar Lote',
        text: 'Este lote será arquivado e não poderá mais ser visualizado, Deseja mesmo confirmar a operação?',
        accept: this.deleteRecord,
        acceptText: 'Sim',
        cancelText: 'Não'
      })
    },
    confirmCustody () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Receber Lote',
        text: 'Você acusa o recebimento deste lote?',
        accept: this.changeCustody,
        acceptText: 'Sim',
        cancelText: 'Cancela'
      })
    },
    async changeCustody () {
      try {
        this.$vs.loading()
        const data = {
          lotId: this.params.data.lotId,
          deviceTimestamp: new Date(),
          custodyChangeCounter: null,
          userDeliveryId: this.params.data.newOwner || this.params.data.userId,
          userId: this.params.data.userId,
          userReceiverId: this.userId,
          locationOriginId: null,
          locationDestinyId: null
        }
        await this.$http.post(
          '/api/v1/admin/custodies', data, { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.showCustodySuccess()
      } catch (err) {
        console.log(err)
        this.showCustodyError()
      } finally {
        this.$router.go()
      }
    },
    async deleteRecord () {
      try {
        this.$vs.loading()
        await this.$http.post(
          `/api/v1/farmers/lots/archives/${this.params.data.lotId}`,
          {},
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.showDeleteSuccess()
      } catch (err) {
        console.log(err)
        this.showDeleteError()
      } finally {
        this.$router.go()
      }
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Lote arquivado',
        text: 'Lote arquivado com sucesso'
      })
    },
    showDeleteError () {
      this.$vs.notify({
        color: 'danger',
        title: 'Lote não arquivado',
        text: 'Erro na arquivação'
      })
    },
    showCustodySuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Lote recebido',
        text: 'Lote recebido com sucesso'
      })
    },
    showCustodyError () {
      this.$vs.notify({
        color: 'danger',
        title: 'Lote não recebido',
        text: 'Erro no recebimento'
      })
    }
  }
}
</script>
